(function () {
	angular
		.module('trackeye')
		.factory('ImageService', ImageService);

	ImageService.$inject = ['$q', 'C4ApiService', 'ImageResizer'];

	function ImageService($q, api, ImageResizer) {
		var exports = {};

		exports.save = function (file, uuid) {
			var defer = $q.defer();

			if (!isValidImage(file)) {
				defer.reject({
					message: 'STR_IMAGE_FORMAT_NOT_SUPPORTED'
				});
			} else {
				var resizer = new ImageResizer(file);

				resizer.ready().then(function(data) {
					upload(data, uuid, defer);
				});
			}

			return defer.promise;
		};

		exports.getImage = function (uuid) {
			return api.forward('get', '/images/'+uuid);
		};

		exports.getImageDataURL = function (uuid) {
			return exports.getImage(uuid).then(function(xhr) {
				var image = xhr.data;
				return "data:"+image.mediaType+";base64, "+image.data;
			});
		};

		function upload(file, uuid, defer) {
			if (uuid) {
				api.forward('delete', '/images/' + uuid);
			}

			api.forward('post', '/images', {
				name: 'te-device',
				data: file.data,
				mediaType: file.type
			}).then(function(xhr) {
				defer.resolve({
					uuid: xhr.getResponseData('id'),
					ext: file.ext
				});
			}, defer.reject);
		}

		function isValidImage(file) {
			var allowed = ['png','jpg','jpeg'],
				valid = file.type.match(/image\/(.+)/);

			if (!valid)
				return false;

			return allowed.indexOf(valid[1]) >= 0;
		}

		return exports;
	}
})();